import { Link } from "react-router-dom";
import { CONTACT } from "@/data";
import { ROUTES } from "@/legal";
import { useI18n } from "@/i18n";

export const Footer = () => {
  const { t } = useI18n();
  return (
    <footer data-testid="site-footer" className="bg-[#1c1c1a] pb-[max(3rem,env(safe-area-inset-bottom))] text-[#f4f4f0]">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="border-t border-[#3a3a37] pt-12">
          <div className="font-display text-[16vw] leading-none tracking-tight text-[#f4f4f0] md:text-[11rem]">
            Bardine <span className="text-[#9e8d7b]">PA.</span>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-[#3a3a37] pt-8 font-body text-[11px] uppercase tracking-[0.18em] text-[#8a8a83] md:flex-row md:items-center md:justify-between" data-testid="footer-address">
          <span className="text-[#c9c9c2]">{CONTACT.address}</span>
          <a href={`tel:${CONTACT.phone.replace(/\s/g, "")}`} className="link-underline">{CONTACT.phone}</a>
          <a href={`mailto:${CONTACT.email}`} className="link-underline text-[#9e8d7b]">{CONTACT.email}</a>
        </div>

        <div className="mt-6 flex flex-col gap-4 border-t border-[#3a3a37] pt-6 font-body text-[11px] uppercase tracking-[0.18em] text-[#5c5c57] md:flex-row md:items-center md:justify-between">
          <span data-testid="footer-copyright">{t.footer.copyright}</span>
          <div className="flex flex-wrap gap-6">
            <Link to={ROUTES.legal} data-testid="footer-legal-link" className="link-underline hover:text-[#f4f4f0]">
              {t.footer.legalNotice}
            </Link>
            <Link to={ROUTES.privacy} data-testid="footer-privacy-link" className="link-underline hover:text-[#f4f4f0]">
              {t.footer.privacy}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
